var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeekLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 172,
    viewBox: "0 0 99 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FeekLogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.6086 53.8491V0.264893C44.2864 0.264893 0.0927817 44.334 0.0927817 98.5033H32.4297C22.2427 107.696 14.1017 118.916 8.53182 131.44C2.96199 143.964 0.0871438 157.513 0.0927817 171.213H53.8283C53.8419 159.374 58.5641 148.024 66.9591 139.653C75.3542 131.282 86.7363 126.573 98.6086 126.56V72.9746C84.1985 72.9635 69.9636 76.1248 56.9201 82.2326C60.2085 73.8752 65.9435 66.6982 73.3789 61.6359C80.8142 56.5736 89.6055 53.8603 98.6086 53.8491Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeekLogo);
export default __webpack_public_path__ + "static/media/FeekLogo.33879e8bd5a137471df44ec78e60c94e.svg";
export { ForwardRef as ReactComponent };